import React from 'react';
import ReactDOM from 'react-dom';

interface PopUpProps{
  closeCallback: () => void;
  children?: React.ReactNode;
}

export class PopUp extends React.Component<PopUpProps> {
  render(): React.ReactNode {
    return ReactDOM.createPortal(
    <div className='absolute top-0 left-0 w-full h-full text-white'>
      <div className='absolute w-full h-full bg-black opacity-50'></div>
      <div className='absolute flex flex-col scrollbar overflow-x-hidden overflow-y-auto justify-start items-center px-4 w-2/3 rounded shadow-lg md:w-1/2 lg:w-1/3 h-2/3 top-[16%] left-[16%] md:left-1/4 lg:left-1/3 bg-modalBackground'>
        <div className='absolute top-[1%] right-[3%] font-extrabold text-2xl cursor-pointer' onClick={() => this.props.closeCallback()}> x </div>
        {this.props.children}
      </div>
    </div>,
    document.getElementById('modalRoot')!
    );
  }
}